import { Phone, Mail, MapPin } from "lucide-react";
import {
  BookLink,
  PHONE_TEL,
  PHONE_DISPLAY,
  EMAIL,
  ADDRESS_LINE,
  ADDRESS_CITY,
  APP_STORE_URL,
} from "./booking";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Gallery", href: "#gallery" },
  { label: "Specials", href: "#specials" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
  { label: "Careers", href: "#careers" },
];

const SERVICES = [
  "Classic Haircuts",
  "Skin Fades & Taper Fades",
  "Beard Trims & Line-Ups",
  "Hot Towel Shaves",
  "Kids & Senior Cuts",
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-border px-5 lg:px-12 pt-16 lg:pt-24 pb-28 md:pb-10">
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <img src="/images/logo-white.png" alt="Faded Barber Co." className="h-12 w-auto mb-6" />
          <p className="text-sm text-muted-foreground font-light leading-relaxed max-w-xs">
            Modern cuts, fresh fades, and professional grooming in Springfield, VA.
          </p>
          <BookLink testid="footer-book-button" className="btn-primary mt-8 !px-6 !py-3">
            Book Now
          </BookLink>
        </div>
        <nav aria-label="Footer">
          <p className="overline mb-6">Explore</p>
          <ul className="space-y-3">
            {NAV.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <p className="overline mb-6">Services</p>
          <ul className="space-y-3">
            {SERVICES.map((s) => (
              <li key={s} className="text-sm text-muted-foreground">
                {s}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="overline mb-6">Contact</p>
          <ul className="space-y-4 text-sm text-muted-foreground">
            <li className="flex gap-3 items-start">
              <MapPin size={15} className="text-primary mt-0.5 shrink-0" aria-hidden="true" />
              <span>
                {ADDRESS_LINE}
                <br />
                {ADDRESS_CITY}
              </span>
            </li>
            <li>
              <a href={PHONE_TEL} data-testid="footer-phone-link" className="flex gap-3 items-center hover:text-primary transition-colors duration-300">
                <Phone size={15} className="text-primary shrink-0" aria-hidden="true" />
                {PHONE_DISPLAY}
              </a>
            </li>
            <li>
              <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="flex gap-3 items-center hover:text-primary transition-colors duration-300">
                <Mail size={15} className="text-primary shrink-0" aria-hidden="true" />
                {EMAIL}
              </a>
            </li>
            <li>
              <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-app-link"
                className="text-link"
              >
                Download the Faded app
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-16 pt-6 border-t border-border flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="font-mono text-xs tracking-[0.15em] text-foreground/50 uppercase">
          © 2026 Faded Barber Co. All Rights Reserved.
        </p>
        <p className="font-mono text-xs tracking-[0.15em] text-foreground/50 uppercase">
          Powered by{" "}
          <a
            href="https://webnehtech.com/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="webnehtech-credit-link"
            className="text-foreground/70 hover:text-primary transition-colors duration-300"
          >
            WebNehTech
          </a>
        </p>
      </div>
    </footer>
  );
}
